import { httpClient } from '../http/httpClient'

export interface UserAdminPinUpdateParams {
  pin: string
}

export const userAdminPinUpdate = async (
  params: UserAdminPinUpdateParams,
  id?: string,
) => {
  if (!id) throw new Error('id required  ')
  const { data } = await httpClient
    .patch(`/user/${id}/password`, params)
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
